import { Grid2 } from "@mui/material";
import React from "react";
import AnalyticsBox from "../Common/AnalyticsBox";

const ContentAnalyticsCards = ({ data }) => {
  return (
    <Grid2 container spacing={2} sx={{ mt: 2 }}>
      <AnalyticsBox
        title="Susbcribers"
        number={data?.subscribers || 0}
        per="/mo"
        small
      />

      <AnalyticsBox
        title="Followers"
        number={data?.followers || 0}
        per="/mo"
        small
      />

      <AnalyticsBox title="Posts" number={data?.posts || 0} per="/mo" small />

      {/* <AnalyticsBox title="Comments" number="120.4K" per="/mo" small />

      <AnalyticsBox
        title="Average Engagement Rate"
        number="543.4K"
        per="/mo"
        small
      />

      <AnalyticsBox
        title="Top-performing content "
        number="333.4K"
        per="/mo"
        small
      /> */}
    </Grid2>
  );
};

export default ContentAnalyticsCards;
